import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.SectionGoodsReceivedNote', {
    title: 'Goods Received Note (GRN)',
    subtitle:
        'ApprovalMax makes tracking the delivery status directly in the Purchase Order easy. Would you like to enable the GRN feature?',
    optionTrue: 'Yes, enable this feature.',
    optionFalse: 'No, I don’t want to use this feature.',
});
